import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import MainComponent from './components/MainComponent';
import LoginPage from './components/LoginPage';
import { ValidationVideoLocalStorageProvider } from './components/ValidationVideoLocalStorage';
import { ValidationContentProvider } from './components/ValidationContentLocalStorage';
import { RuleTestPlaygroundProvider } from './components/RuleTestPlaygroundLocalStorage';
import ProceedComponent from './components/ProceedComponent';
import AccessDeniedComponent from './components/AccessDeniedComponent';
import SignUpComponent from './components/SignUpComponent';
import AdminApproval from './components/AdminApproval';
import PageNotFound from './components/PageNotFound'; // ✅ Import NotFound
import { ValidationJobProvider } from './components/ValidationJobContext';
import { ReferenceDatasetJobProvider } from './components/ReferenceDatasetJobContext';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Navigate } from "react-router-dom";
import appConfig from "./config/appConfig.json";


// ✅ Toastify Imports
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const loginRoute = appConfig.loginRoute;



function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ValidationJobProvider>
      <ReferenceDatasetJobProvider>
        <RuleTestPlaygroundProvider>
          <ValidationVideoLocalStorageProvider>
            <ValidationContentProvider>
              <Router>
                <div className="App">
                  {/* ✅ GLOBAL TOAST CONTAINER */}
                  <ToastContainer />
                  <Routes>

                    {/* TO run application using 'localhost:3000/mcv/login'(login page will open at this location) path, uncomment below line and comment the next line */}
                    {/* <Route path="/mcv/login" element={<LoginPage />} /> */}

                    {/* To run application using 'localhost:3000'(login page will open at this location) path, uncomment below line and comment the previous line */}
                    {/* <Route path="/" element={<LoginPage />} /> */}

                    {/* Dynamic login route based on appConfig.json, you can set it to either "/mcv/login" or "/" as per your requirement */}
                    <Route path={loginRoute} element={<LoginPage />} />

                    <Route path="/mcv/signup" element={<SignUpComponent />} />
                    <Route path="/mcv/admin-approval" element={<AdminApproval />} />
                    <Route path='/mcv/proceed' element={<ProceedComponent/>} />
                    <Route path='/mcv/access-denied' element={<AccessDeniedComponent/>} />
                    {/* All /mcv main routes */}
                    <Route path="/mcv/*" element={<MainComponent />} />
                    {/* Global 404 fallback */}
                    {/* <Route path="*" element={<PageNotFound />} /> */}

                  </Routes>

                  <ToastContainer 
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                  />
                  
                </div>
              </Router>
            </ValidationContentProvider>
          </ValidationVideoLocalStorageProvider>
        </RuleTestPlaygroundProvider>
      </ReferenceDatasetJobProvider>
      </ValidationJobProvider>
    </LocalizationProvider>
  );
}

export default App;